// extracted by mini-css-extract-plugin
export default {"buttonLink":"UVaSIl"};